import React from 'react';
import cx from 'classnames';
import { constants as C } from '@trucktrax/trucktrax-common';
import styles from './MarkerLabel.module.css';

export interface MarkerLabelProps {
  name: string;
  color: string;
  containerStyles?: any;
}

export default function MarkerLabel(props: MarkerLabelProps) {
  const { name, color, containerStyles }: MarkerLabelProps = props;
  let mergedContainerStyles = { background: color };
  if (containerStyles) {
    mergedContainerStyles = { ...mergedContainerStyles, ...containerStyles };
  }
  return (
    <div
      className={styles.labelContainer}
      style={mergedContainerStyles}
      data-test="vehicle-hover-detail-panel"
    >
      <span
        className={cx(
          styles.text,
          color === C.STATUS_COLORS.InQueue ||
            color === C.STATUS_COLORS.UnloadStart ||
            color === C.STATUS_COLORS.Returning
            ? styles.labelTextBlack
            : styles.labelTextWhite,
        )}
      >
        {name}
      </span>
    </div>
  );
}
